export default __webpack_public_path__ + "static/redwood-1-2acd6fb8f6a099a9eec826bf8f200167.jpg";